const STORAGE_KEY = 'athilio_admin_auth';

export function saveCredentials(username: string, password: string): void {
  sessionStorage.setItem(STORAGE_KEY, btoa(`${username}:${password}`));
}

export function getAuthHeader(): string | null {
  const stored = sessionStorage.getItem(STORAGE_KEY);
  if (!stored) return null;
  return `Basic ${stored}`;
}

export function clearCredentials(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function isLoggedIn(): boolean {
  return sessionStorage.getItem(STORAGE_KEY) !== null;
}
